module.exports = __webpack_public_path__ + "img/roadhog.27822665.svg";